module.exports = __webpack_public_path__ + "img/logo.c0c401a5.png";